import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pa-4" }
const _hoisted_2 = { class: "d-flex align-center mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "text-h5 font-weight-bold" }, "Planificare Anuală Concedii", -1)),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_select, {
        modelValue: _ctx.an,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.an) = $event)),
          _ctx.incarca
        ],
        items: _ctx.ani,
        label: "An",
        variant: "outlined",
        density: "compact",
        style: {"max-width":"100px"},
        class: "mr-3"
      }, null, 8, ["modelValue", "items", "onUpdate:modelValue"]),
      _createVNode(_component_v_btn, {
        color: "red-darken-1",
        "prepend-icon": "mdi-plus",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogLinie = true))
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
          _createTextVNode("Adaugă perioadă", -1)
        ]))]),
        _: 1
      })
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          color: "red-darken-1",
          class: "mb-2"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.linii,
      "show-borders": true,
      "row-alternation-enabled": true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxColumn, {
          "data-field": "Luna",
          caption: "Luna",
          width: 80
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataInceput",
          caption: "Data start",
          "data-type": "date",
          format: "dd.MM.yyyy",
          width: 130
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataSfarsit",
          caption: "Data sfârșit",
          "data-type": "date",
          format: "dd.MM.yyyy",
          width: 130
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NumarZile",
          caption: "Zile",
          width: 70
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "TipConcediu",
          caption: "Tip",
          width: 120
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Observatie",
          caption: "Observații"
        }),
        _createVNode(_component_DxPaging, { enabled: false })
      ]),
      _: 1
    }, 8, ["data-source"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialogLinie,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dialogLinie) = $event)),
      "max-width": "480",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { rounded: "xl" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  class: "mr-2",
                  color: "red-darken-1"
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("mdi-calendar-plus", -1)
                  ]))]),
                  _: 1
                }),
                _cache[12] || (_cache[12] = _createTextVNode(" Perioadă planificare ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  modelValue: _ctx.linieValid,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.linieValid) = $event)),
                  ref: "linieForm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.linieForm.DataInceput,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.linieForm.DataInceput) = $event)),
                              label: "Data start",
                              type: "date",
                              variant: "outlined",
                              density: "compact",
                              rules: [_ctx.required]
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.linieForm.DataSfarsit,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.linieForm.DataSfarsit) = $event)),
                              label: "Data sfârșit",
                              type: "date",
                              variant: "outlined",
                              density: "compact",
                              rules: [_ctx.required]
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.linieForm.TipConcediu,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.linieForm.TipConcediu) = $event)),
                      label: "Tip concediu",
                      variant: "outlined",
                      density: "compact",
                      class: "mt-2"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.linieForm.Observatie,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.linieForm.Observatie) = $event)),
                      label: "Observații",
                      variant: "outlined",
                      density: "compact",
                      rows: "2",
                      class: "mt-2"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_ctx.saveError)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 0,
                      type: "error",
                      variant: "tonal",
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.saveError), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogLinie = false))
                }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createTextVNode("Anulează", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "red-darken-1",
                  loading: _ctx.saveLoading,
                  disabled: !_ctx.linieValid,
                  onClick: _ctx.salveaza
                }, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createTextVNode("Salvează", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading", "disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}